import React, { useEffect } from "react";
import { ArrowUpRight, ExternalLink } from "lucide-react";
import "./MainContent.css";
import Project_image_3 from "../assests/project_image_1.jpg"
import Project_image_4 from "../assests/project_image_3.png"
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from "react-router-dom";


const OurService = () => {
  useEffect(() => {
      AOS.init({
        duration: 1000,
        once: true,
      });
      window.scrollTo(0, 0);
    }, []);

  const services = [
    {
      id: "01",
      title: "PROJECT ORiONß",
      description: "Advancing sustainable human and robotic presence in space by developing AI-driven autonomous systems for 6U LEO satellites, multi-payload integration, and IoT-enabled M2M communication, while exploring translunar space and galactic cosmic radiation for innovative deep-space solutions.",
      path: "/project/project1",
      bgImage: Project_image_3 // Replace with actual image path
    },
    {
      id: "02",
      title: "RiGEL UCAV On SWaP Platform",
      description: "The RiGEL UCAV leverages advanced machine and deep learning to enhance ISR capabilities by synthesizing vast sensor data more efficiently, while optimizing size, weight, and power (SWaP) to maximize payload efficiency and enable cutting-edge performance in defence operations.",
      path: "/project/project2",
      bgImage: Project_image_4 // Replace with actual image path
    },
  ];

  return (
    <div className=" bg-white">
      <div className="container mx-auto px-4 py-8">
        
        <div className="w-full p-4 sm:px-8 md:px-12 lg:p-8 bg-white">
          <div className="w-full flex justify-center items-center relative px-4 sm:px-8 md:px-16 lg:px-24">
          <h1 
          className="font-nova-square text-4xl sm:text-5xl md:text-6xl font-bold text-center text-gray-800 after:absolute after:top-10 after:sm:top-16 after:lg:top-16 after:2xl:top-16 after:bottom-0 after:left-0 after:w-[100%] after:h-1 after:bg-blue-700 after:transform after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300" 
          data-aos="fade-up">
            Our Projects
            {/* <div className="absolute w-full h-1 top-full left-0 mt-1 bg-blue-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div> */}
          </h1>
          </div>
        </div>

        {/* Services Grid with enhanced cards and background images */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-8 max-w-7xl mx-auto mt-4 ">
        {services.map((service) => (
          <div
            key={service.id}
            className="group relative cursor-pointer flex flex-col lg:flex-row bg-gray-800/50 rounded-2xl overflow-hidden"
          >
            {/* Animated gradient border */}
            <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 rounded-2xl opacity-0 group-hover:opacity-100 blur-xl transition-all duration-700 animate-gradient-x" />
            
            {/* Image Section */}
            <div className="relative lg:w-1/2 aspect-[4/3] overflow-hidden">
              <div className="absolute inset-0 transform transition-transform duration-700 ease-out group-hover:scale-110">
                <img
                  src={service.bgImage}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-gray-900/50 group-hover:opacity-75 transition-opacity duration-500" />
              </div>
            </div>

            {/* Content Section */}
            <div className="relative lg:w-1/2 p-8 flex flex-col justify-center">
              <div className="transform transition-all duration-500 group-hover:translate-x-2">
                {/* Service Title */}
                <h3 className="text-2xl lg:text-2xl font-bold text-white mb-4 group-hover:text-blue-400 transition-colors duration-300">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-300 leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Call to Action */}
                <Link to={service.path} className="inline-flex items-center space-x-2 text-white font-semibold group-hover:text-blue-400">
                  <span className="relative">
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-400 group-hover:w-full transition-all duration-300" />
                    Learn More
                  </span>
                  <ArrowUpRight className="w-5 h-5 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default OurService;